import { OnInit, Component, Injectable, ViewChild } from "@angular/core";
import { MatButtonToggle } from '@angular/material/button-toggle';
import { Kurs } from "../_models/kurs";
import { Kursteilnehmer } from "../_models/teilnehmer";
import { Fehlzeiten } from "../_models/fehlzeiten";
import { KursService } from "../_services/kurs.service";
import { Data } from "@angular/router";
import { DateTime } from "../_helpers/DateTime";
import { InhalteService } from "../_services/inhalte.service";
import { Klassenbuch } from "../_models/klassenbuch";
import { AuthenticationService } from "../_services/authentication.service";
import { User } from "../_models/user";
import { TeilnehmerService } from "../_services/teilnehmer.service";
import { AnwesenheitService } from "../_services/anwesenheit.service";
//import { Observable, Subscription } from "rxjs";
import { ChooseCoursesComponent } from "../_components/choose-courses.component";


//export interface DialogData {
//  course: Kurs;
//  student: Kursteilnehmer;
//  absenceData: Fehlzeiten;
//}

@Component({
  templateUrl: 'management.component.html'
})
@Injectable()
export class ManagementComponent implements OnInit {


  student: Kursteilnehmer;
  absenceData: Fehlzeiten;
  course: Kurs;
  courses: Kurs[];
  holidays: Klassenbuch[];
  contents: Klassenbuch[];
  unexcusedChecked: boolean = true;


  Timespan: boolean = false;
  AddAbsence: boolean = false;
  IsTrainer: boolean = false;
  IsCoach: boolean = false;
  IsManagement: boolean = false;

  isAbsencesActive: boolean = true;
  isEntriesActive: boolean = false;
  isReportsActive: boolean = false;
  isCourseActive: boolean = false;

  resetSelectedCourses: boolean = false;

  @ViewChild(ChooseCoursesComponent) choosecourse: ChooseCoursesComponent;

  constructor(private absenceService: AnwesenheitService, private studentService: TeilnehmerService, private courseService: KursService, private contentService: InhalteService, private authService: AuthenticationService) { }

  ngOnInit() {
    this.courseService.getKurse().subscribe(x => this.courses = x, err => console.log(err));
    //this.contentService.getHolidays().subscribe(x => this.holidays = x, err => console.log(err), () => console.log(this.holidays));
  }

  AddAbsenceIsCanceled(): void {
    this.AddAbsenceChanged('');
    console.log(this.AddAbsence);
  }

  AddAbsenceChanged(view: string) {
    this.AddAbsence = !this.AddAbsence;
    if (view == "Time") {
      this.Timespan = false;
    }
    if (view == "Timespan") {
      this.Timespan = true;
    }
    console.log(view);
  }

  onStudentChanged(selectedStudent: Kursteilnehmer): void {
    console.log('mgmtComp onStudentChanged');
    console.log(selectedStudent);
    this.student = selectedStudent;
    this.course = this.courses.filter(x => x.kursNr == this.student.kursNr).shift();
    this.contentService.getInhaltebykurs(this.course).subscribe(
      x => this.contents = x,
      err => { },
      () => this.holidays = this.contents.filter(y => y.thema == "Ferien")
    );
    //this.holidays = this.holidays.filter(x => x.kurs.kursNr == this.student.kursNr);
    //console.log(this.holidays);
  }

  courseName(studCourseNumber: number): string {
    return this.courses.filter(c => c.kursNr == studCourseNumber).shift().kursName;
  }

  menuSelect(event) {
    this.isAbsencesActive = false;
    this.isEntriesActive = false;
    this.isReportsActive = false;
    this.isCourseActive = false;
    switch (event.srcElement.id) {
      case 'absence':
        this.isAbsencesActive = true;
        break;
      case 'entries':
        this.isEntriesActive = true;
        break;
      case 'reports':
        this.isReportsActive = true;
        break;
      case 'course':
        this.isCourseActive = true;
    }
    console.log(event.srcElement.id);

  }

  //switchMenu(to: string): void {
  //  switch (to) {
  //    case 'toTrainer':
  //      this.IsTrainer = true; this.IsManagement = false; this.IsCoach = false;
  //      break;
  //    case 'toCoach':
  //      this.IsTrainer = false; this.IsManagement = false; this.IsCoach = true;
  //      break;
  //    case 'toManagement':
  //      this.IsTrainer = false; this.IsManagement = true; this.IsCoach = false;
  //      break;
  //  }
  //}

  onUnexcuseChanged(event) {
    this.unexcusedChecked = event;
    console.log(this.unexcusedChecked);
  }

  //CourseDetail(studCourseNumber: number) {
  //  console.log(studCourseNumber);
  //}

  GenerateReport(event) {
    if (this.student.kursteilnehmerNr == event.target.id) {
      //let data = document.getElementsByClassName("Items-Container")[0].innerHTML;
      let newWindow = window.open("about:blank", "Bericht");
      console.log(this.course.kursbeginn);
      console.log(this.course.kursEnde);
      console.log(this.course);
      if (this.course.kursNr == this.student.kursNr) {
        let start: number = Date.parse(this.course.kursbeginn) - 7200000;
        let ende: number = Date.parse(this.course.kursEnde)
        let startDate: Date = new Date(start);
        let datePointer: Date = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        this.generateTemplate(this.student, this.course);
        //this.reportTemplateTableBody += '<tr><td>' + DateTime.GetMonthString(startDate.getMonth()) +
        //  ' ' + startDate.getFullYear().toString().substr(2, 2) + '</td>';
        ende = new Date().valueOf() < ende ? new Date().valueOf() : ende;
        for (var i = datePointer.valueOf() - 7200000; i <= ende; i = i + DateTime.MilliSecondsOfDay) {
          let actDate: Date = new Date(i);
          if (actDate.getDate() == 1)
            this.reportTemplateTableBody += '</tr><tr><th class="month">' + DateTime.GetMonthString(actDate.getMonth()) + ' ' + ' ' + actDate.getFullYear().toString().substr(2, 2) + '</th>';
          if (i < start) {
            this.reportTemplateTableBody += '<td class="table-default text-muted"></td>';
          } else {
            this.reportTemplateTableBody += this.GenerateReportDateRecord(actDate);
          }
        }
        this.reportTemplateTableBody += '</tr>';
      }
      newWindow.document.write(this.reportTemplateHeader + this.reportTemplateTableHeader + this.reportTemplateTableBody + this.reportTemplateFooter);
      newWindow.focus();
    }
  }

  GenerateReportDateRecord(date: Date): string {
    console.log(this.student.fehlzeiten);
    let absences = this.student.fehlzeiten.filter(x => x.datum.substr(0, 10) == date.toISOString().substr(0, 10));
    //let absence: Fehlzeiten;
    //if (absences.length > 0) absence = absences.shift();
    let innerHTML: string = '<td ';
    console.log(date.toISOString().substr(0, 10));
    console.log(absences);
    if (absences[0] != undefined && absences[0].bis == "16:30:00" && absences[0].von == "08:15:00") {
      switch (absences[0].entschuldigung) {
        case "entschuldigt": innerHTML += 'class="table-primary">E</td>'; break;
        case "krank": innerHTML += 'class="table-warning">K</td>'; break;
        case "Sonderurlaub": innerHTML += 'class="table-info">S</td>'; break;
        case "unentschuldigt": innerHTML += 'class="table-danger">U</td>'; break;
        default: innerHTML += 'class="table-secondary">?</td>'; break;
      }
      console.log(date);
      console.log(date.toISOString());

    } else if (this.holidays.filter(x => x.eintragsDatum.substr(0, 10) == date.toISOString().substr(0, 10)).length > 0) {
      innerHTML += 'class="table-dark">F</td>';
    } else if (date.getDay() == 0 || date.getDay() == 6) {
      innerHTML += 'class="table-secondary text-muted">We</td>';
    } else if (this.contents.filter(x => x.eintragsDatum.substr(0, 10) == date.toISOString().substr(0, 10)).length == 0) {
      innerHTML += 'class="table-light">?</td>';
    } else {
      innerHTML += 'class="table-success">A</td>';
    }
    return innerHTML;
  }

  reportTemplateHeader: string;
  reportTemplateTableHeader: string;
  reportTemplateTableBody: string;
  reportTemplateFooter: string;
  generateTemplate(_student: Kursteilnehmer, _course: Kurs) {

    this.reportTemplateHeader =
      '<!DOCTYPE html>\n' +
      '<html lang="de">\n' +
      '<head> <meta charset="UTF-8"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <meta http-equiv="X-UA-Compatible" content="ie=edge"> <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"> <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"> <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js"></script> <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"></script> <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js"></script> <link rel="icon" type="image/ico" href="Logo-miniatur_80px_x_80px.png"><style type="text/css">td,th{text-align: center;}.month{text-align: right;}</style> <title>Bericht</title>\n' +
      '</head>\n';
    this.reportTemplateTableHeader =
      '<body style="margin: 1.5em;"> <div class="h1">Teilnehmer:<span id="studentname">' + _student.nachname + ', ' + _student.vorname + '</span></div>' +
      '<div class="h2">Kurs:<span id="coursename">' + _course.kursName + '</span></div> <table class="table"> <thead> <th class="month">Monat</th> <th>1</th> <th>2</th> <th>3</th> <th>4</th> <th>5</th> <th>6</th> <th>7</th> <th>8</th> <th>9</th> <th>10</th> <th>11</th> <th>12</th> <th>13</th> <th>14</th> <th>15</th> <th>16</th> <th>17</th> <th>18</th> <th>19</th> <th>20</th> <th>21</th> <th>22</th> <th>23</th> <th>24</th> <th>25</th> <th>26</th> <th>27</th> <th>28</th> <th>29</th> <th>30</th> <th>31</th> </thead> <tbody>';
    this.reportTemplateTableBody = '';
    this.reportTemplateFooter =
      '</tbody> </table >\n' +
      '</body>\n' +
      '</html>';
  }


  ClassBookSelectedCourses: Kurs[];
  ClassBookTopic: string;
  ClassBookContent: string;
  ClassBookTrainer: User = this.authService.user;
  user: User = this.authService.user;
  ClassBookEntry: Klassenbuch;


  onAssumeCourses(assumedCourses: Kurs[]) {

    this.ClassBookSelectedCourses = assumedCourses;
    this.resetSelectedCourses = false;
    this.ClassBookSelectedCourses.forEach((item, index, array) => {
      //console.log("Kursindex: " + index);
      item.teilnehmer = null
      this.studentService.GetTnByKurs(item.kursNr).subscribe(
        students => item.teilnehmer = students,
        err => console.log(err),
        () => item.teilnehmer.forEach(
          (student, i, a) => {
            this.absenceService.getFehlzeitenByTn(student.kursteilnehmerNr).subscribe(
            x => student.fehlzeiten = x,
            err => console.log(err),
            () => { console.log(student); console.log(student.fehlzeiten); }
            )
          }
          )
      )
    });
    this.ClassBookEntry = this.choosecourse.getClassBookEntry();
    //console.log(this.ClassBookSelectedCourses);
    //console.log("Klassenbuch: ");
    //console.log(this.ClassBookEntry);
    //console.log(this.choosecourse.getClassBookEntry());
  }

  onClassBookEntrySaved(entry: Klassenbuch) {
    this.ClassBookEntry = null;
    this.resetSelectedCourses = true;
  }

  onClassBookEntryCanceled() {
    this.ClassBookEntry = null;
    this.resetSelectedCourses = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/Management/management.component.ts